import React from 'react';
import { routerRedux, Route, Switch } from 'dva/router';
import { LocaleProvider } from 'antd';
// import moment from 'moment';
// 国际化资源
import strore from 'store';
// import { addLocaleData } from 'react-intl';
// import 'moment/locale/zh-cn';
import enAntd from 'antd/lib/locale-provider/en_US';
import zhAntd from 'antd/lib/locale-provider/zh_CN';
// import enLocaleData from 'react-intl/locale-data/en';
// import zhLocaleData from 'react-intl/locale-data/zh';
// import enMessages from '../locales/en.json';
// import zhMessages from '../locales/zh.json';

// layouts
import Header from '../components/Header/';

import { getRouterData } from './config';
import ScrollToTop from '../components/ScrollToTop';
import NotFound from '../views/NotFound/';

// addLocaleData([...enLocaleData, ...zhLocaleData]);
const locale = strore.get('locale') || 'zh';
let appLocale = {};
switch (locale) {
  case 'zh':
    // moment.locale('zh-cn');
    appLocale = {
      locale: 'zh',
      // messages: zhMessages,
      antdLocale: zhAntd,
    };
    break;
  case 'en':
    // moment.locale('en');
    appLocale = {
      locale: 'en',
      // messages: enMessages,
      antdLocale: enAntd,
    };
    break;
  default:
}

const { ConnectedRouter } = routerRedux;
function componentWrap(withHeader, component, props) {
  const CustomComponent = component;
  return (
    <React.Fragment>
      {withHeader ? <Header {...props} /> : null}
      <CustomComponent {...props} />
    </React.Fragment>
  );
}

function RouterConfig({ history, app }) {
  const routerData = getRouterData(app);
  return (
    <LocaleProvider locale={appLocale.antdLocale}>
      {/* <IntlProvider locale={appLocale.locale} messages={appLocale.messages}> */}
        <ConnectedRouter history={history}>
          <ScrollToTop>
            <Switch>
              {
                routerData.map(({ path, component, exact, header }) => {
                  return (
                    <Route
                      key={path}
                      path={path}
                      render={(props) => { return componentWrap(header, component, props); }}
                      exact={exact}
                    />
                  );
                })
              }
              <Route component={NotFound} />
            </Switch>
          </ScrollToTop>
        </ConnectedRouter>
      {/* </IntlProvider> */}
    </LocaleProvider>
  );
}

export default RouterConfig;
